import { ResourceResponseObject } from '../models/entities/AzureResources/ResourceResponseObject';
import VirtualMachineRequest from '../models/entities/VirtualMachineRequest';
import { VirtualMachineModel } from '../models/viewModels/Subscriptions/VMProvisioningModel';
import ApiClient from './ApiClient';

export default class VirtualMachineRequestService extends ApiClient {

	async getVirtualMachineRequestById(virtualMachineRequestId: number) {
		return this.get<VirtualMachineRequest>(`VirtualMachineRequest/${virtualMachineRequestId}`);
	}

	async getAllVirtualMachinesInSubscription(subscriptionId: string) {
		return this.get<VirtualMachineRequest[]>(`VirtualMachineRequest/${subscriptionId}/bySubscriptionId`);
	}

	async getStartingNumberByPrefix(subscriptionId: string, environment: string, serverNamePrefix: string) {
		return this.get<VirtualMachineRequest>(`VirtualMachineRequest/${subscriptionId}/${environment}/${serverNamePrefix}`);
	}

	async createVM(subscriptionId: number, model: VirtualMachineModel){
		return this.post<any>(`VirtualMachineRequest/${subscriptionId}`, model);
	}

	async checkDuplicatedNames(finalName: string[]){
		return this.post<any>(`VirtualMachineRequest/checkDuplicatedNames`, finalName);
	}
}